import { jsx as E } from "react/jsx-runtime";
import o from "react";
import { $ as m } from "../index-C1KmDBa6.js";
const l = Symbol("Uninitialized");
function v(e, ...t) {
  const r = o.useRef(l);
  return r.current === l && (r.current = e(...t)), r.current;
}
function a(e) {
  const t = o.useRef(e);
  return t.current = e, t;
}
function i(e, t = "keydown", r) {
  o.useEffect(() => {
    const s = (n) => {
      i.shouldProcessEvent(n) && e.current(n);
    };
    return window.addEventListener(t, s, r), () => {
      window.removeEventListener(t, s, r);
    };
  }, [t, r]);
}
i.shouldProcessEvent = (e) => {
  if (e.target instanceof Element) {
    if (e.target.hasAttribute("contenteditable"))
      return !1;
    switch (e.target.tagName) {
      case "INPUT":
      case "SELECT":
      case "TEXTAREA":
        return !1;
      default:
        return !0;
    }
  }
  return !0;
};
function d(e) {
  const t = a((r) => {
    d.isCloseEvent(r) && e();
  });
  i(t);
}
d.isCloseEvent = (e) => e.key === "Escape";
function R(e) {
  const t = a(e);
  o.useEffect(() => {
    const r = () => t.current();
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []);
}
function b(e) {
  const {
    children: t
  } = e;
  return /* @__PURE__ */ E("div", { style: { display: "none" }, children: t });
}
function g(e, t = "original") {
  const [r, s] = o.useState(() => b);
  return o.useEffect(() => {
    let n = document.getElementById(e);
    if (n || (n = document.createElement("div"), n.id = e, document.body.appendChild(n)), t !== "original") {
      const c = n, u = `${e}_${t}`;
      n = document.getElementById(u), n || (n = document.createElement("div"), n.id = u, t === "before" ? document.body.insertBefore(n, c) : c.after(n));
    }
    const f = ({
      children: c
    }) => m.createPortal(c, n);
    s(() => f);
  }, [e, t]), r;
}
export {
  a as useDynamicRef,
  i as useGlobalKeyboardEvent,
  v as useInstance,
  d as useKeyboardClose,
  g as useOutlet,
  R as useWindowResize
};
